import React from 'react';
import { Button } from '@appkit4/react-components/button';

interface PreviewComponentProps {
  title: string;
  filePreview: string;
  generaHtml: boolean;
  onDownload?: () => void;
  isDownloading?: boolean;
  downloadUrl?: string;
}

const PreviewComponent: React.FC<PreviewComponentProps> = ({ 
  title, 
  filePreview, 
  generaHtml,
  onDownload,
  isDownloading,
  downloadUrl
}) => {
  const truncatedTitle = title.slice(0, -4) + ".txt";

  return (
    <div className="preview-container" style={{ 
      width: '90%', 
      maxWidth: '800px', 
      padding: '20px', 
      borderRadius: '10px', 
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', 
      transition: 'box-shadow 0.3s'
    }}>
      {filePreview && (
        <>
          <div
            className="preview-header"
            style={{
              backgroundColor: '#FFA500',
              background: '#D04A02',
              padding: '10px',
              borderRadius: '8px 8px 0 0',
              cursor: 'pointer',
            }}
          >
            <h3 style={{ 
              margin: 0, 
              marginBottom: 0,
              color: '#fff', 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap' 
            }}>
              Output file: {truncatedTitle}
            </h3>
          </div>
          <div style={{ 
            position: 'relative',
            backgroundColor: '#f0f0f0',
            borderRadius: '0 0 8px 8px'
          }}>
            <div 
              className="file-preview" 
              style={{ 
                whiteSpace: 'pre',
                maxHeight: '550px',
                overflowX: 'auto', 
                overflowY: 'scroll',
                color: '#333', 
                padding: '20px', 
                margin: '0px 0',
                width: '100%',
                maxWidth: '100%'
              }}
            >
              <div style={{ whiteSpace: 'pre', minWidth: '600px' }}>
                {filePreview}
              </div>
            </div>
            {downloadUrl && (
              <div style={{ 
                position: 'sticky',
                bottom: '20px',
                right: '20px',
                float: 'right',
                marginTop: '-60px',
                marginRight: '20px',
                zIndex: 10
              }}>
                  <Button
                    kind="primary"
                    icon="icon-download-outline"
                    disabled={!downloadUrl || isDownloading}
                    loading={isDownloading}
                    onClick={onDownload}
                  >
                    Download
                  </Button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewComponent;